// extracted by mini-css-extract-plugin
export default {"eventsRoute":"EventsRoute_eventsRoute__sMfJV"};